import { InjectionToken } from '@angular/core';

export const NgChartjsCustomPluginToken: InjectionToken<any> = new InjectionToken<any[]>('[ngx-chart-js] Global Default Plugin');

